export const brandBuilderInitialState = {
  cities: {
    data: [],
    loading: false,
    error: null,
  },
  entitiesList: {
    data: [],
    loading: false,
    error: null,
    total: 0,
  },
  createEntity: {
    data: null,
    loading: false,
    error: null,
  },
  editEntity: {
    data: null,
    loading: false,
    error: null,
  },
  removeEntity: {
    data: null,
    loading: false,
    error: null,
  },
  shareEntity: {
    data: null,
    loading: false,
    error: null,
  },
  industries: {
    data: [],
    loading: false,
    error: null,
  },
  sectors: {
    data: [],
    loading: false,
    error: null,
  },
  brandDepartment: {
    data: null,
    loading: false,
    error: null,
  },
  brandCompetitiors: {
    data: [],
    loading: false,
    error: null,
  },
  brandCompetitiorSuggestions: {
    data: [],
    total: 0,
    loading: false,
    error: null,
  },
  removeBrandCompetitior: {
    data: null,
    loading: false,
    error: null,
  },
  addBrandCompetitior: {
    data: null,
    loading: false,
    error: null,
  },
  activeEntity: {
    data: null,
    loading: false,
    error: null,
  },
  digikalaBrandsSearch: {
    data: [],
    loading: false,
    error: null,
    pendingRequestId: null,
  },
};
